const MESSAGE = {
  GLOBAL: {
    REQUIRED: "Esse campo é obrigatório!",
    REQUIRED_FIELD: (field: string) => dynamicFieldMessage(field, "é obrigatório!"),

    MIN_LENGTH: (min: number) => `O campo deve ter pelo menos ${min} caracteres.`,
    MIN_LENGTH_FIELD: (field: string, min: number) => dynamicFieldMessage(field, `deve ter pelo menos ${min} caracteres.`),

    MAX_LENGTH: (max: number) => `O campo não pode ter mais de ${max} caracteres.`,
    MAX_LENGTH_FIELD: (field: string, max: number) => dynamicFieldMessage(field, `não pode ter mais de ${max} caracteres.`),

    LENGTH: (length: number) => `O campo deve ter exatamente ${length} caracteres.`,
    LENGTH_FIELD: (field: string, length: number) => dynamicFieldMessage(field, `deve ter exatamente ${length} caracteres.`),

    NOT_EMPTY: "O campo não pode ficar vazio!",
    NOT_EMPTY_FIELD: (field: string) => dynamicFieldMessage(field, "não pode ficar vazio."),

    NOT_REPEATED: "O campo não pode conter caracteres repetidos.",
    NOT_REPEATED_FIELD: (field: string) => dynamicFieldMessage(field, "não pode conter caracteres repetidos."),

    NOT_SEQUENCED: "O campo não pode conter uma sequência numérica.",
    NOT_SEQUENCED_FIELD: (field: string) => dynamicFieldMessage(field, "não pode conter uma sequência numérica.")
  },

  PRIMITIVES: {
    STRING: {
      ONLY_CHARS: "Apenas letras são permitidas!",
      NOT_HAS_SPECIAL_CHARS: "Caracteres especiais não são permitidos!",
      NOT_HAS_DOUBLE_SPACES: "Espaços duplos não são permitidos!",
      INVALID_TYPE: "O campo deve ser uma string!"
    },
    NUMBER: {
      ONLY_NUMBERS: "Apenas números são permitidos!"
    }
  },

  EMAIL: {
    INVALID: "E-mail inválido!",
    INVALID_FIELD: (field: string) => dynamicFieldMessage(field, "deve ser um e-mail válido.")
  },

  CPF: {
    INVALID: "CPF inválido! O CPF deve ter o formato válido 000.000.000-00.",
    INVALID_FIELD: (field: string) => dynamicFieldMessage(field, "deve ser um CPF válido.")
  },

  CNPJ: {
    INVALID: "CNPJ inválido! O CNPJ deve ter o formato válido 00.000.000/0000-00.",
    INVALID_FIELD: (field: string) => dynamicFieldMessage(field, "deve ser um CNPJ válido.")
  },

  CPF_OR_CNPJ: {
    INVALID: "CPF ou CNPJ inválido! Informe um CPF (000.000.000-00) ou CNPJ (00.000.000/0000-00) válido.",
    INVALID_FIELD: (field: string) => dynamicFieldMessage(field, "deve ser um CPF ou CNPJ válido.")
  },

  CEP: {
    INVALID: "CEP inválido!",
    INVALID_FIELD: (field: string) => dynamicFieldMessage(field, "deve ser um CEP válido.")
  },

  CNH: {
    INVALID: "CNH inválida! A CNH deve ter o formato válido.",
    INVALID_FIELD: (field: string) => dynamicFieldMessage(field, "deve ser uma CNH válida.")
  },

  PASSWORD: {
    MIN_LENGTH: "A senha deve ter pelo menos 8 caracteres.",
    MAX_LENGTH: "A senha não pode ter mais de 72 caracteres.",
    UPPERCASE: "A senha deve conter pelo menos uma letra maiúscula.",
    LOWERCASE: "A senha deve conter pelo menos uma letra minúscula.",
    NUMBER: "A senha deve conter pelo menos um número.",
    SPECIAL_CHAR: "A senha deve conter pelo menos um caractere especial.",
    NOT_MATCH: "As senhas não coincidem."
  },

  BIRTHDAY: {
    INVALID: "Data de nascimento inválida!",
    INVALID_FIELD: (field: string) => dynamicFieldMessage(field, "deve ser uma data válida."),

    NOT_IN_FUTURE: "A data de nascimento não pode ser no futuro.",
    NOT_IN_FUTURE_FIELD: (field: string) => dynamicFieldMessage(field, "não pode ser no futuro."),

    NOT_IN_PAST: "A data de nascimento não pode ser no passado.",
    NOT_IN_PAST_FIELD: (field: string) => dynamicFieldMessage(field, "não pode ser no passado."),

    NOT_OLDER_THAN_120: "A data de nascimento não pode ser mais antiga que 120 anos.",
    NOT_OLDER_THAN_120_FIELD: (field: string) => dynamicFieldMessage(field, "não pode ser mais antiga que 120 anos."),

    NOT_YOUNGER_THAN_18: "Você deve ter pelo menos 18 anos.",
    NOT_YOUNGER_THAN_18_FIELD: (field: string) => dynamicFieldMessage(field, "deve ter pelo menos 18 anos.")
  },

  PHONE: {
    INVALID: "Telefone inválido!",
    INVALID_FIELD: (field: string) => dynamicFieldMessage(field, "deve ser um telefone válido.")
  },

  PLATE: {
    INVALID: "Placa inválida! A placa deve ter o formato válido ABC1A23 ou ABC1234.",
    INVALID_FIELD: (field: string) => dynamicFieldMessage(field, `deve estar no formato ABC1A23 ou ABC1234.`)
  }
} as const;

const dynamicFieldMessage = (field: string, message: string) => {
  return `O campo ${field} ${message}`;
};

export { MESSAGE };
